module.exports = __webpack_public_path__ + "static/media/concept-r.439e7a00.png";